module.exports = __webpack_public_path__ + "img/blade_alpha.6a2a0056.jpg";